import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {createRequestOption} from "../../shared/util/request-util";
import {IPhoneType} from "../../shared/model/phone-type.model";
import {SERVER_API_URL} from "../../app.constants";



type EntityResponseType = HttpResponse<IPhoneType>;
type EntityArrayResponseType = HttpResponse<IPhoneType[]>;

@Injectable({ providedIn: 'root' })
export class PhoneTypeService {
    public resourceUrl = SERVER_API_URL + 'api/phone-types';

    constructor(protected http: HttpClient) {}

    create(phoneType: IPhoneType): Observable<EntityResponseType> {
        return this.http.post<IPhoneType>(this.resourceUrl, phoneType, { observe: 'response' });
    }

    update(phoneType: IPhoneType): Observable<EntityResponseType> {
        return this.http.put<IPhoneType>(this.resourceUrl, phoneType, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IPhoneType>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IPhoneType[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }
}
